exports = module.exports = require("../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-transmit__upload-area{width:100%;border-radius:1rem;border:2px dashed #bdbdbd;min-height:30vh}@media (min-height:1000px){.v-transmit__upload-area{min-height:300px}}.v-transmit__upload-area--is-dragging{background:#e1f5fe linear-gradient(-45deg,#fafafa 25%,transparent 0,transparent 50%,#fafafa 0,#fafafa 75%,transparent 0,transparent);background-size:40px 40px}", "", {"version":3,"sources":["/app/node_modules/vue-transmit/dist/vue-transmit.css"],"names":[],"mappings":"AAAA,yBAAyB,WAAW,mBAAmB,0BAA0B,eAAe,CAAC,2BAA2B,yBAAyB,gBAAgB,CAAC,CAAC,sCAAsC,qIAAqI,yBAAyB,CAAC","file":"vue-transmit.css","sourcesContent":[".v-transmit__upload-area{width:100%;border-radius:1rem;border:2px dashed #bdbdbd;min-height:30vh}@media (min-height:1000px){.v-transmit__upload-area{min-height:300px}}.v-transmit__upload-area--is-dragging{background:#e1f5fe linear-gradient(-45deg,#fafafa 25%,transparent 0,transparent 50%,#fafafa 0,#fafafa 75%,transparent 0,transparent);background-size:40px 40px}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-transmit/dist/vue-transmit.css
// module id = 717
// module chunks = 4 5